import { ApiError, NETWORK_ERROR_TYPE } from './errors';

const RETRY_DELAY_MS = 1500;

const MAX_QUERY_RETRIES = 3;

/** A read that failed on the way (dropped connection or a 5xx) can succeed on a second try; a 4xx will not. */
export function shouldRetryQuery(failureCount: number, err: unknown): boolean {
  if (failureCount >= MAX_QUERY_RETRIES) return false;
  if (!(err instanceof ApiError)) return true;
  return err.status === 0 || err.status >= 500;
}

/** The request never reached the server, so nothing it would have done happened. */
export function isTransportFailure(err: unknown): boolean {
  return err instanceof ApiError && err.errorType === NETWORK_ERROR_TYPE;
}

// Reached only once the bytes are already held in memory, so the file is not the
// suspect here and the copy must not send the candidate back to the file picker.
export const UPLOAD_INCOMPLETE_MESSAGE =
  'We could not send your application. Please check your connection and try again.';

/**
 * Runs `send` a second time when the first attempt never reached the server.
 *
 * Only a transport failure is retried, because it is the only outcome that
 * proves the server did no work. Anything carrying an HTTP status may already
 * have taken effect and must not be repeated.
 */
export async function retryOnTransportFailure<T>(send: () => Promise<T>): Promise<T> {
  try {
    return await send();
  } catch (err) {
    if (!isTransportFailure(err)) throw err;
    await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
    return send();
  }
}
